import { gql } from '@apollo/client';

export const GET_INVOICE_LIST = gql`
  query GetInvoiceList($filter: InvoiceFilterInput, $page: Int, $size: Int) {
    settlement {
      invoices(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            title
            host {
              id
              name
            }
            totalPayment {
              value
              currencyCode
            }
            feeForReceivable {
              value
              currencyCode
            }
            paymentForPayable {
              value
              currencyCode
            }
            paymentForReceivable {
              value
              currencyCode
            }
            bankAccount {
              bank {
                code
                name
              }
              accountNo
              holder
            }
            createdAt
            startedAt
            completedAt
            status
          }
        }
      }
    }
  }
`;

export const GENERATE_INVOICES_FILE = gql`
  mutation GenerateInvoicesFileForHost($filter: InvoiceFilterInput!) {
    generateInvoicesFileForHost(filter: $filter) {
      success
      message
      url
    }
  }
`;
